export default {"src":"/_next/static/media/group.7c8371d0.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};